export default "__VITE_ASSET__BwG5W4W3__"